export default "__VITE_ASSET__CRSgL6yc__"